export default function homeReducer(state = [], action) {
    switch (action.type) {
        case "SET_HOME_DATA":
            return Object.assign([], action.homeData);
        default:
            return state;
    }
}